// TODO: we need to omit all the properties that we override or else TS just
// &s them!!
export function isDeliverabilityMetricInsight(insight) {
  return insight.insightCategory === 'DELIVERABILITY_METRIC';
}